/**
 * 確保測量容器中的 <br> 標籤不佔用高度
 * 因為實際樣式中 br { display: none; }
 */
const applyBrStyles = (container) => {
  const brElements = container.querySelectorAll('br');
  brElements.forEach(br => {
    br.style.display = 'none';
  });
};

/**
 * 隱藏 MathML 的 <annotation> / <annotation-xml> 元素。
 * 現代瀏覽器支援 MathML Core（<math> display: math），會自動隱藏 annotation。
 * 但 Electron 內嵌的舊版 Chromium 不支援 MathML Core（<math> display: inline），
 * 會把 annotation 內的長編碼字串（如 MathType-MTEF）當成可見文字渲染，
 * 導致測量高度暴增。此函式確保 annotation 在任何環境都不影響高度測量。
 */
const hideMathAnnotations = (container) => {
  container.querySelectorAll('annotation, annotation-xml').forEach(el => {
    el.remove();
  });
};

/**
 * 限制測量容器中的圖片最大高度，與實際顯示一致
 */
const applyImgConstraints = (container, maxHeight) => {
  if (maxHeight > 0) {
    container.querySelectorAll('img').forEach(img => {
      img.style.maxHeight = `${maxHeight}px`;
      img.style.objectFit = 'contain';
    });
  }
};

/**
 * 創建用於測量的臨時容器
 */
export const createMeasureContainer = (referenceContainer, outerWrapperClassName = '') => {
  const measureContainer = document.createElement('div');
  const containerStyle = window.getComputedStyle(referenceContainer);
  
  measureContainer.style.position = 'absolute';
  measureContainer.style.visibility = 'hidden';
  measureContainer.style.width = referenceContainer.offsetWidth + 'px';
  measureContainer.style.fontSize = containerStyle.fontSize;
  measureContainer.style.lineHeight = containerStyle.lineHeight;

  // 存儲容器高度，供圖片約束使用
  measureContainer._containerHeight = referenceContainer.clientHeight;

  // 在 measureContainer 內建立 inner wrapper，還原實際 DOM 的祖先結構
  // 不在 measureContainer 上設 fontFamily inline style，讓 inner wrapper
  // 的 class-based CSS（如 .simple.MATH.SECONDARY { font-family: Times New Roman }）
  // 不會被 inline style 覆蓋
  if (outerWrapperClassName) {
    const innerWrapper = document.createElement('div');
    innerWrapper.className = outerWrapperClassName;
    measureContainer.appendChild(innerWrapper);
    measureContainer._innerContainer = innerWrapper;

    // 重導 innerHTML 到 _innerContainer，讓既有的 paging.js 不需改動
    // setter 中同時隱藏 annotation，確保直接設定 innerHTML 的路徑也能正確測量
    Object.defineProperty(measureContainer, 'innerHTML', {
      get() { return innerWrapper.innerHTML; },
      set(html) {
        innerWrapper.innerHTML = html;
        hideMathAnnotations(innerWrapper);
      },
      configurable: true
    });
  }

  measureContainer.setHTMLAndApplyBrStyles = function(html) {
    const target = this._innerContainer || this;
    target.innerHTML = html;
    applyBrStyles(target);
    hideMathAnnotations(target);
  };

  return measureContainer;
};
